import React from "react";
import { useTranslation } from "react-i18next";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const handleChange = (e) => {
    const newLang = e.target.value;
    i18n.changeLanguage(newLang);
    localStorage.setItem("lang", newLang);
  };

  return (
    <FormControl
      fullWidth
      size="small"
      sx={{ mb: 2, alignSelf: "flex-end", maxWidth: 180 }}
    >
      <InputLabel id="language-select-label">Language</InputLabel>
      <Select
        labelId="language-select-label"
        value={i18n.language}
        label="Language"
        onChange={handleChange}
      >
        <MenuItem value="en_US_English">English</MenuItem>
        <MenuItem value="fr_CA_Français">Français</MenuItem>
        {/* Add more languages if needed */}
      </Select>
    </FormControl>
  );
};

export default LanguageSwitcher;
